import React from "react"
import PropTypes from "prop-types"
import styles from "./styles.js"
import Fab from "@material-ui/core/Fab"
import CancelIcon from "@mui/icons-material/Cancel"
import SaveIcon from "@mui/icons-material/Save"

const RememberSelectionBtn = ({
	handleRememberComponentSelection,
	rememberComponentSelection,
	handleComponentSelection,
}) => {
	const styling = styles()

	return (
		<Fab
			className={styling.rememberSelectionBtn}
			color="primary"
			size="small"
			aria-label="save component selected to scan"
			onClick={() => {
				handleRememberComponentSelection(!rememberComponentSelection)
				if (!rememberComponentSelection) handleComponentSelection({})
			}}
		>
			{rememberComponentSelection ? <CancelIcon /> : <SaveIcon />}
		</Fab>
	)
}

export default RememberSelectionBtn

RememberSelectionBtn.propTypes = {
	handleRememberComponentSelection: PropTypes.func.isRequired,
	rememberComponentSelection: PropTypes.bool.isRequired,
	handleComponentSelection: PropTypes.func.isRequired,
}
